import { Provider, ProviderType } from './types';

export class ProviderRegistry {
  private providers: Map<ProviderType, Provider> = new Map();

  registerProvider(provider: Provider): void {
    this.providers.set(provider.type, provider);
  }

  getProvider(type: ProviderType): Provider | undefined {
    return this.providers.get(type);
  }

  getAllProviders(): Provider[] {
    return Array.from(this.providers.values());
  }

  getEnabledProviders(): Provider[] {
    return this.getAllProviders().filter((provider) => provider.isEnabled);
  }
}
